import {strTrimRight as trimRight} from '@/utils/string'

export const strTrimRight = (value, chars, isRegexp = true) => {
	return trimRight(value, chars, isRegexp)
}